// Tysiąc is not a solitaire: its own module plays it (1000/, .ai/tysiac.md). This stand-in only gives the shell a game id it
// knows (menu, Games window, options, New game / Retry, the shuffle pattern of the first deal): no columns, no
// foundations, the 52 cards stay on a stock nobody sees (the module keeps the 24 it plays); no card can be moved here.
import type { VariantRules } from './base';

export const thousand: VariantRules = {
  id: 'thousand',
  columns: [],
  foundations: 0,
  cells: 0,
  decks: 1,
  suits: ['c', 's', 'd', 'h'],
  variableSuits: 0,
  turn: 1,
  hasWaste: false,
  recycle: false,
  allFaceUp: false,
  autoMove: false,
  foundationToTableau: false,
  canLift: () => false,
  canDrop: () => false,
  foundationFor: () => null,
  buildsOn: () => false,
  completedRun: () => false,
  isWon: () => false,
  table: '1000',
};
